module.exports = __webpack_public_path__ + "img/carshina22_07.07a647cc.jpg";